import {GET_SUBMENU1, SUBMENU1_ERROR} from '../types'

const initialState = {
    subMenu1:[],
    loading:true
}

export default function(state = initialState, action){

    switch(action.type){

        case GET_SUBMENU1:
        return {
            ...state,
            subMenu1:action.payload,
            loading:false

        }
        case SUBMENU1_ERROR:
            return{
                loading: false, 
                error: action.payload 
            }
        default: return state
    }

}